import {Form, Input, InputNumber, message, ModalProps, Skeleton} from 'antd';
import React from 'react';
import Style from './index.module.scss';
import {useMutation, useQuery} from 'react-query';
import {ProModal} from '../../../../../../Components/ProModal';
import {
    getServiceDetail,
    getServiceDirectoryOptions,
    LevelType,
    saveServiceDetail,
    SaveServiceProps,
    ServiceType,
} from '../../../service';
import SelectDict from '../../../../../../Features/Select/SelectDict';
import {useDict} from '../../../dict';
import {SimpleSwitch} from '../../../../../../Features/Fields/SimpleSwitch';
import {isEmpty} from '../../../../../../Stores/commonStore';
import {IconType} from '../../../../../../Utils/publicEnum';
import {UploadSinglePhoto} from '../../../../../../Features/Upload/UploadSinglePhoto';
import RulesAntd from '../../../../../../Utils/rulesAntd';
import FormIconSelect from 'Components/FormComponents/FormIconSelect';

interface Props extends ModalProps {
    type?: ServiceType;
    id?: string;
    parentId?: string;
    onOk: () => void;
}

const Index = ({id, onOk, type, parentId, ...props}: Props) => {
    const [form] = Form.useForm<SaveServiceProps>();
    const dict = useDict();

    const onBaseSave = useMutation({
        mutationFn: saveServiceDetail,
        onSuccess: () => {
            message.success('成功!');
            onOk();
        },
    });

    const defaultData = useQuery({
        queryKey: ['getServiceDetail', id],
        queryFn: () => getServiceDetail(id),
        onSuccess: res => {
            form.setFieldsValue(res!);
        },
    });

    const getMenu = useQuery({
        queryKey: ['getServiceDirectoryOptions', parentId],
        queryFn: () => getServiceDirectoryOptions(parentId),
    });

    function onFinish(formData: any) {
        if (parentId && formData.levelType === LevelType?.Directory) {
            formData.parentId = parentId;
        }
        if (type === ServiceType.Service) {
            formData.parentId = parentId;
        }
        onBaseSave.mutate({
            ...formData,
            id,
        });
    }

    const iconType = Form.useWatch('iconType', form);
    const levelType = Form.useWatch('levelType', form) as LevelType;

    return (
        <ProModal
            {...props}
            width={800}
            title={`编辑${type === ServiceType.Service ? '服务' : '菜单'}`}
            onOk={form.submit}>
            <div className={Style.root}>
                <Skeleton active loading={defaultData.isFetching}>
                    {defaultData && (
                        <Form
                            labelCol={{span: 6}}
                            wrapperCol={{span: 15}}
                            form={form}
                            onFinish={onFinish}>
                            <Form.Item
                                name="name"
                                label="名称"
                                rules={[RulesAntd.Required]}>
                                <Input />
                            </Form.Item>
                            <Form.Item
                                name="code"
                                label="编码"
                                rules={[RulesAntd.Required]}>
                                <Input disabled={!isEmpty(id)} />
                            </Form.Item>
                            {type !== ServiceType.Service && (
                                <>
                                    <Form.Item
                                        name="levelType"
                                        label="级别"
                                        rules={[RulesAntd.Required]}>
                                        <SelectDict
                                            onSelect={() => {
                                                form.setFieldValue(
                                                    'parentId',
                                                    null,
                                                );
                                            }}
                                            disabled={!isEmpty(id)}
                                            options={dict.MenuType.data}
                                        />
                                    </Form.Item>
                                    {levelType !== LevelType.Directory && (
                                        <Form.Item
                                            name="parentId"
                                            label="所属目录"
                                            rules={[RulesAntd.Required]}>
                                            <SelectDict
                                                fieldNames={{
                                                    label: 'name',
                                                    value: 'id',
                                                }}
                                                disabled={!isEmpty(id)}
                                                options={getMenu?.data}
                                            />
                                        </Form.Item>
                                    )}
                                </>
                            )}
                            {[LevelType.Menu, LevelType.H5Menu].includes(
                                levelType,
                            ) && (
                                <Form.Item
                                    name="menuUrl"
                                    label="url"
                                    rules={[RulesAntd.Required]}>
                                    <Input />
                                </Form.Item>
                            )}
                            <Form.Item name="status" label="状态">
                                <SimpleSwitch />
                            </Form.Item>
                            {type !== ServiceType.Service && (
                                <>
                                    <Form.Item
                                        name="manageShowType"
                                        initialValue="0"
                                        label="管理端展示">
                                        <SimpleSwitch />
                                    </Form.Item>
                                    <Form.Item name="iconType" label="图标类型">
                                        <SelectDict
                                            options={dict.IconType.data}
                                            onSelect={() =>
                                                form.setFieldValue(
                                                    'h5Icon',
                                                    null,
                                                )
                                            }
                                        />
                                    </Form.Item>
                                    {[
                                        IconType.Antd,
                                        IconType.AntdMobile,
                                    ].includes(iconType) && (
                                        <Form.Item
                                            name="h5Icon"
                                            label="图标"
                                            tooltip="颜色仅供参考">
                                            <FormIconSelect
                                                iconType={iconType}
                                            />
                                        </Form.Item>
                                    )}
                                    {[
                                        IconType.WebSvg,
                                        IconType.WebImg,
                                    ].includes(iconType) && (
                                        <Form.Item
                                            name="h5Icon"
                                            label="图标"
                                            tooltip="颜色仅供参考">
                                            <UploadSinglePhoto />
                                        </Form.Item>
                                    )}
                                    <Form.Item name="h5Sort" label="移动端排序">
                                        <InputNumber />
                                    </Form.Item>
                                    <Form.Item
                                        name="h5ShowType"
                                        label="H5/校友展示">
                                        <SelectDict
                                            options={dict.H5ShowType.data}
                                        />
                                    </Form.Item>
                                </>
                            )}

                            <Form.Item name="description" label="说明">
                                <Input.TextArea />
                            </Form.Item>
                        </Form>
                    )}
                </Skeleton>
            </div>
        </ProModal>
    );
};

export default Index;
